export interface DefaultCountryFlag {
  code: string;
  flag: string;
  name: string;
}

const FLAG_BASE_URL = "https://flagcdn.com/w320";

const DEFAULT_COUNTRY_FLAGS = [
  country("Algeria", "dz", ["ALG"]),
  country("Argentina", "ar", ["ARG"]),
  country("Australia", "au", ["AUS"]),
  country("Austria", "at", ["AUT"]),
  country("Belgium", "be", ["BEL"]),
  country("Bosnia and Herzegovina", "ba", ["BIH", "Bosnia"]),
  country("Brazil", "br", ["BRA"]),
  country("Canada", "ca", ["CAN"]),
  country("Cape Verde", "cv", ["CPV", "Cabo Verde"]),
  country("Colombia", "co", ["COL"]),
  country("Croatia", "hr", ["CRO"]),
  country("Curacao", "cw", ["CUW", "Curaçao"]),
  country("Czechia", "cz", ["CZE", "Czech Republic"]),
  country("DR Congo", "cd", [
    "COD",
    "Democratic Republic of the Congo",
    "Congo DR",
    "DRC",
  ]),
  country("Ecuador", "ec", ["ECU", "Equador"]),
  country("Egypt", "eg", ["EGY"]),
  country("England", "gb-eng", ["ENG"]),
  country("France", "fr", ["FRA"]),
  country("Germany", "de", ["GER", "DEU"]),
  country("Ghana", "gh", ["GHA"]),
  country("Haiti", "ht", ["HAI"]),
  country("Iran", "ir", ["IRN"]),
  country("Iraq", "iq", ["IRQ"]),
  country("Ivory Coast", "ci", ["CIV", "Cote d'Ivoire", "Côte d'Ivoire"]),
  country("Japan", "jp", ["JPN"]),
  country("Jordan", "jo", ["JOR"]),
  country("Mexico", "mx", ["MEX"]),
  country("Morocco", "ma", ["MAR"]),
  country("Netherlands", "nl", ["NED", "HOL", "Holland"]),
  country("New Zealand", "nz", ["NZL"]),
  country("Norway", "no", ["NOR"]),
  country("Panama", "pa", ["PAN"]),
  country("Paraguay", "py", ["PAR", "PRY"]),
  country("Portugal", "pt", ["POR"]),
  country("Qatar", "qa", ["QAT"]),
  country("Saudi Arabia", "sa", ["KSA", "SAU"]),
  country("Scotland", "gb-sct", ["SCO"]),
  country("Senegal", "sn", ["SEN"]),
  country("South Africa", "za", ["RSA", "ZAF"]),
  country("South Korea", "kr", ["KOR", "Korea Republic", "Republic of Korea"]),
  country("Spain", "es", ["ESP", "SPA"]),
  country("Sweden", "se", ["SWE"]),
  country("Switzerland", "ch", ["SUI", "CHE"]),
  country("Tunisia", "tn", ["TUN"]),
  country("Turkiye", "tr", ["TUR", "Turkey", "Türkiye"]),
  country("USA", "us", ["United States", "United States of America", "US"]),
  country("Uruguay", "uy", ["URU"]),
  country("Uzbekistan", "uz", ["UZB"]),
] as const;

const DEFAULT_COUNTRY_FLAGS_BY_KEY = new Map<string, DefaultCountryFlag>();

for (const entry of DEFAULT_COUNTRY_FLAGS) {
  DEFAULT_COUNTRY_FLAGS_BY_KEY.set(normalizeCountryKey(entry.name), entry);
  DEFAULT_COUNTRY_FLAGS_BY_KEY.set(normalizeCountryKey(entry.code), entry);

  for (const alias of entry.aliases) {
    DEFAULT_COUNTRY_FLAGS_BY_KEY.set(normalizeCountryKey(alias), entry);
  }
}

export function getDefaultCountryFlag(
  country?: string,
): DefaultCountryFlag | undefined {
  const key = normalizeCountryKey(country);

  return key ? DEFAULT_COUNTRY_FLAGS_BY_KEY.get(key) : undefined;
}

function country(name: string, code: string, aliases: string[] = []) {
  return {
    aliases,
    code,
    flag: `${FLAG_BASE_URL}/${code}.png`,
    name,
  };
}

function normalizeCountryKey(value?: string): string {
  return value?.trim().toLocaleLowerCase() ?? "";
}
